import { HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { ACCESS_TOKEN_COOKIE } from '@core/auth.constants';

// Override token for requests that need a specific Bearer token (e.g. public agent mode)
export const BEARER_TOKEN_OVERRIDE = new HttpContextToken<string | null>(() => null);

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  //console.log('Interceptor: Processing request:', req.url);

  const overrideToken = req.context.get(BEARER_TOKEN_OVERRIDE);

  let modifiedReq = req.clone({
    withCredentials: true
  });

  if (overrideToken) {
    modifiedReq = modifiedReq.clone({
      setHeaders: {
        'Authorization': `Bearer ${overrideToken}`
      }
    });
    // console.log('Added Authorization header with override Bearer token');
  } else {
    // Проверяем сначала signed-in-as-user-token в localStorage (приоритет для админской авторизации)
    const signedInAsToken = localStorage.getItem('signed-in-as-user-token');

    if (signedInAsToken) {
      // Используем токен подмены пользователя
      modifiedReq = modifiedReq.clone({
        setHeaders: {
          'Authorization': `Bearer ${signedInAsToken}`
        }
      });
      console.log('Added Authorization header with signed-in-as-user token');
    } else {
      // Получаем access_token из cookies для обычной авторизации
      const accessToken = getCookieValue(ACCESS_TOKEN_COOKIE);

      // Добавляем Authorization header если есть токен
      if (accessToken) {
        modifiedReq = modifiedReq.clone({
          setHeaders: {
            'Authorization': `Bearer ${accessToken}`
          }
        });
       //  console.log('Added Authorization header with Bearer token');
      } else {
        console.log('No access_token found in cookies');
      }
    }
  }

  // Add x-space-id header from selected space in localStorage
  try {
    const spaceJson = localStorage.getItem('selected_space');
    if (spaceJson) {
      const spaceId = JSON.parse(spaceJson)?.id;
      if (spaceId) {
        modifiedReq = modifiedReq.clone({
          setHeaders: { 'x-space-id': spaceId }
        });
      }
    }
  } catch {}

  return next(modifiedReq);
};

// Вспомогательная функция для получения cookie по имени
function getCookieValue(name: string): string | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
}